module.exports = __webpack_public_path__ + "static/media/27.8c09cd6b.jpg";